import { useAuth } from "@/context/AuthContext";
import { useGame } from "@/context/GameContext";
import { api } from "@/lib/api";
import { Coins, Heart, LogOut, Users } from "lucide-react";

export function TopBar({ onOpenPanel }) {
  const { setUser, user } = useAuth();
  const { snap, online } = useGame();
  const hpPct = snap?.max_hp ? Math.max(0, Math.min(100, (snap.current_hp / snap.max_hp) * 100)) : 100;

  async function logout() {
    try { await api.post("/api/auth/logout"); } catch (e) { /* noop */ }
    setUser(false);
    window.location.href = "/";
  }

  return (
    <header
      className="h-16 px-4 flex items-center justify-between panel"
      style={{ borderRadius: 0, borderLeft: "none", borderRight: "none", borderTop: "none" }}
      data-testid="topbar"
    >
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2" data-testid="topbar-brand">
          <img src="/favicon-96.png" alt="Territoria: Life" className="w-9 h-9 rounded shadow-[0_0_0_1px_rgba(180,140,60,0.35)]" />
          <div className="font-display text-xl heading-gilded hidden sm:block">Territoria</div>
        </div>
        <div className="hidden md:flex items-center gap-3">
          <div className="w-10 h-10 rounded-full border border-amber-800 bg-stone-900 flex items-center justify-center font-display text-amber-400 text-lg" data-testid="topbar-portrait">
            {(snap?.name || user?.name || "A").slice(0, 1).toUpperCase()}
          </div>
          <div>
            <div className="font-display text-lg leading-tight" data-testid="topbar-name">
              {snap?.name || user?.name || "Adventurer"}
            </div>
            <div className="text-stone-500 text-[10px] uppercase tracking-widest font-numeric">
              Wanderer of Territoria
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div className="hidden sm:flex flex-col items-end w-40">
          <div className="flex items-center gap-1 text-xs text-red-300 font-numeric">
            <Heart size={12} className="fill-red-500 text-red-500" />
            {snap?.current_hp ?? "-"} / {snap?.max_hp ?? "-"}
          </div>
          <div className="hp-bar-outer w-full mt-1">
            <div className="hp-bar-fill" style={{ width: `${hpPct}%` }} data-testid="topbar-hp-fill" />
          </div>
        </div>

        <div className="flex items-center gap-1.5 panel px-3 py-1.5" data-testid="topbar-gold">
          <Coins size={14} className="text-amber-400" />
          <span className="font-numeric text-amber-300">{(snap?.gold ?? 0).toLocaleString()}</span>
        </div>

        <div className="hidden md:flex items-center gap-1.5 text-stone-400 text-sm font-body" data-testid="topbar-online">
          <Users size={14} className="text-emerald-500" />
          <span className="font-numeric text-emerald-400">{online}</span> online
        </div>

        <button
          onClick={logout}
          className="btn-ghost-gold p-2"
          title="Log out"
          data-testid="topbar-logout"
        >
          <LogOut size={16} />
        </button>
      </div>
    </header>
  );
}
